import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
  expandedUserRoleContainer: css({
    boxSizing: "border-box",
    padding: 24,
    width: "100%",
    maxHeight: 480,
    backgroundColor: Color.primary[400],
  }),
  expandedUserRoleExpandIcon: css({
    position: "absolute",
    top: 16,
    right: 16,
    "& svg": {
      width: 24,
      height: 24,
      color: Color.neutral[100],
      transform: "rotate(180deg)"
    }
  }),
  expandedUserRoleHeader: css({
    marginTop: 16,
    display: "inline-flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "90%",
  }),
  expandedUserRoleListContainer: css({
    marginTop: 16,
    marginBottom: 30,
    maxHeight: 250,
    overflowY: "auto"
  }),
  expandedUserRoleListAction: css({
    "& svg": {
      width: 20,
      height: 20,
      color: Color.neutral[300]
    }
  }),
  userRoleFunctionContainer: css({
    height: 73,
    textAlign: "center"
  }),
  userRoleFunction: css({
    width: 80,
    position: "relative",
    "& svg": {
      width: 40,
      height: 40,
      color: Color.neutral[100]
    }
  }),
  functionStatusContainer: css({
    display: "inline-flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "90%",
  }),
  functionStatus: css({
    width: 80,
    textAlign: "center",
    color: Color.neutral[100],
    "& svg": {
      width: 20,
      height: 20,
      color: Color.neutral[100]
    }
  }),
});
